
export default {
  props: {
    icon: {
      type: String,
      default: 'info'
    },
    title: {
      type: String,
      default: 'Information'
    },
    description: {
      type: String,
      default: null
    }
  },
  vessel: {
    box: {
      padding: 'sm',
      backgroundColor: 'grey-lighter',
      borderRadius: 'lg'
    }
  },
  computed: {
    imagePath() {
      return `/${this.icon}.svg`
    }
  }
}
